import {
  Dropdown,
  DropdownItem,
  DropdownList,
  FileUploader,
  Input,
  Textarea
} from '@cokitchen/cokitchen-components';
import { ArrowDownIcon } from 'cokitchen-icons';
import React from 'react';
import { STORAGE_KEYS } from 'utils/constants';
import { BrandType, CreateMealXlsType, MealCategoryType } from 'utils/types';

type ReviewBaseMealXlsItemType = {
  meal: Partial<CreateMealXlsType>;
  mealIndex: number;
  show: boolean;
  isReview: boolean;
  toggleAccordion: () => void;
  handleReviewClick: (meal: Partial<CreateMealXlsType>) => void;
  brands: BrandType[];
  mealCategories: MealCategoryType[];
  updateMeal: (i: number, name: string, e: any) => void;
};
const ReviewBaseMealXlsItem = ({
  meal,
  mealIndex,
  show,
  toggleAccordion,
  handleReviewClick,
  updateMeal,
  isReview,
  brands
}: ReviewBaseMealXlsItemType) => {
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  return (
    <div
      className={`rounded-xl border border-[#EDEDEE] w-full max-w-[698px] ${
        isReview ? 'text-gray-4' : ' text-gray-6'
      }`}>
      <div
        className='py-4 px-[20px] border-b border-b-[#EDEDEE] flex cursor-pointer justify-between items-center'
        onClick={toggleAccordion}>
        <div className='flex gap-3 items-center'>
          🍔
          <p className='text-sm'>{meal.name}</p>
        </div>
        <button
          disabled={isReview || meal?.hasError}
          className={`font-medium text-sm rounded border border-[#E7E8E9] shadow py-[6px] w-[86px] flex justify-center items-center cursor-pointer hover:bg-gray-light bg-opacity-90 first-letter:first-linemarker: ${
            meal.hasError && 'text-gray-4'
          }
          `}
          onClick={() => handleReviewClick(meal)}>
          {isReview ? 'Reviewed' : 'Review'}
          {meal.hasError && <div className=' h-2 w-2  bg-red-5 rounded-full ml-1' />}
        </button>
      </div>
      {show ? (
        <div className='py-4 px-[20px]'>
          <div className='flex gap-6 flex-wrap mb-2 justify-between'>
            <div className='w-[346px]'>
              <div className='w-full mb-5'>
                <div className='w-full mb-7'>
                  <div className='flex items-center'>
                    <p className='text-sm font-medium mb-1'>Parent brand</p>
                  </div>

                  <Dropdown
                    content={
                      <div className='w-full rounded border border-[#E6E5E5] py-[14px] pl-[20px] pr-[14px] flex justify-between items-center h-[50px]'>
                        <p className='text-sm'>{meal?.parent_brand_id || 'No brand selected'}</p>
                        <ArrowDownIcon />
                      </div>
                    }>
                    <DropdownList className={`${isReview ? 'hidden' : 'block'}`}>
                      {brands?.map((brand, i) => (
                        <DropdownItem
                          key={i}
                          onClick={() => {
                            updateMeal(mealIndex, 'parent_brand_id', brand.name);
                          }}>
                          {brand.name}
                        </DropdownItem>
                      ))}
                    </DropdownList>
                  </Dropdown>
                </div>
              </div>

              <div className='w-full mb-4'>
                <div className='flex items-center'>
                  <p className='text-sm font-medium mb-1'>Item Name</p>
                  {!meal.name && <div className=' h-2 w-2  bg-red-5 rounded-full ml-1' />}
                </div>
                <Input
                  disabled={isReview}
                  placeholder='Item Name'
                  type='text'
                  inputClass={`h-[50px] border-gray-1 ${isReview ? 'text-gray-4' : ' text-gray-6'}`}
                  value={meal.name}
                  onChange={(e) => updateMeal(mealIndex, 'name', e)}
                  className='text-sm'
                />
              </div>
            </div>
            <div className='w-[269px]'>
              <div className='w-full mb-5'>
                <FileUploader
                  token={token ?? ''}
                  disabled={isReview}
                  fileUrls={meal.images ? meal.images : []}
                  setFileUrls={(imgUrl) => updateMeal(mealIndex, 'images', [imgUrl])}
                />
              </div>

              {meal.calories && (
                <div className='relative'>
                  <div className='flex items-center'>
                    <p className='text-sm font-medium mb-1'>Calories</p>
                    {!meal.amount && <div className=' h-2 w-2  bg-red-5 rounded-full ml-1' />}
                  </div>
                  <Input
                    disabled={isReview}
                    type='text'
                    placeholder='Enter Calories'
                    value={meal?.calories ?? ''}
                    onChange={(e) => updateMeal(mealIndex, 'calories', e)}
                    className='text-sm'
                    inputClass={`h-[50px] border-gray-1 ${
                      isReview ? 'text-gray-4' : ' text-gray-6'
                    }`}
                  />
                </div>
              )}
            </div>
          </div>
          {meal?.description && (
            <Textarea
              disabled={isReview}
              label='Item Description'
              className='border-gray-1 text-sm'
              placeholder='item description'
              value={meal.description || ''}
              onChange={(e) => updateMeal(mealIndex, 'description', e)}
              rows={3}
            />
          )}
        </div>
      ) : null}
    </div>
  );
};

export default ReviewBaseMealXlsItem;
